import { render, staticRenderFns } from "./statementList.vue?vue&type=template&id=31934019&scoped=true"
import script from "./statementList.vue?vue&type=script&lang=js"
export * from "./statementList.vue?vue&type=script&lang=js"
import style0 from "./statementList.vue?vue&type=style&index=0&id=31934019&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31934019",
  null
  
)

export default component.exports